import { useEffect } from "react";

function useDynamicTabTitle(title: string, prefix: string = "Odi") {
	useEffect(() => {
		// Set the tab title when the component using this hook mounts
		document.title = `${prefix} · ${title}`;
		return () => {
			// Reset the tab title when the component unmounts
			document.title = "ODI";
		};
	}, [title]);
}

export default useDynamicTabTitle;
